import React from "react";
import "./footer.css"; 

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        
        <div className="social-links">
          <a href="https://github.com/Midplayz" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="https://www.linkedin.com/in/srivishnu-srinivasan/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="https://midplayz.itch.io/" target="_blank" rel="noopener noreferrer">Itch.io</a>
        </div>

        <p className="creator-text">
          Designed, Developed, and Maintained by <span className="highlight">Srivishnu</span>
        </p>

        <p className="copyright">© {currentYear} All Rights Reserved</p>
        
      </div>
    </footer>
  );
};

export default Footer;